<div class="modal__header">
	<div class="modal__header-actions header-actions--mobile">
		<button [attr.aria-label]="'bookingSearch.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
			<app-svg svg="icons.svg#general--arrow--left-no_margin" aria-hidden="true" [alt]="'Arrow left icon'"></app-svg>
		</button>
	</div>
	<div class="title_wrapper">
		<h2 class="title" id="modal__title">{{INDRA_printTitle()}}</h2>
	</div>
	<div class="modal__header-actions header-actions">
		<button [attr.aria-label]="'bookingSearch.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>

<div class="modal__body select-themes-body sl--scrollable">
	<div class="input-text__wrapper has-clear">
		<input class="input-text" placeholder="{{ 'bookingSearch.text.countryCityAirport' | ibeadmin | async }}" [value]="INDRA_printAirportName"
			(focus)="INDRA_handleInputFocus($event)" (blur)="INDRA_handleInputBlur($event)"
			(keyup)="INDRA_handleInputChange($event)" autocomplete=false type="text" id="select-airport-mobile-modal" autofocus>
		<app-svg *ngIf="INDRA_printAirportName" class="input-text__clear" svg="icons.svg#general--close" role="button" [alt]="'Clear input'" (click)="INDRA_clearInput()"></app-svg>
		<label class="visuallyhidden" for="select-airport-mobile-modal">{{INDRA_printTitle()}}</label>
	</div>
	<app-autocomplete class="autocomplete--modal" [id]="id" [callback]="callback" [focused]="hasFocus" [completeOptions]="completeOptions" [dataOptions]="dataOptions" [showResults]="showAutocomplete" [query]="query"
		(selected)="INDRA_handleSelect($event)"></app-autocomplete>
</div>
